module.exports = __webpack_public_path__ + "media/images/patent/x_6-eada75a89f166d9cbe23502a759fc61f.png";